/**
 * Referral Status Utilities
 *
 * Utility functions for handling referral status labels and formatting.
 *
 * @module utils/referralStatus
 */

/**
 * Get human-readable label for referral status
 */
export const getStatusLabel = (status: string): string => {
  switch (status) {
    case 'pending':
      return 'Pending patient booking';
    case 'claimed':
      return 'Patient to Schedule';
    case 'scheduled':
      return 'Appointment Scheduled';
    case 'no_show':
      return 'Patient No-Show';
    case 'awaiting_mealplan':
      return 'Awaiting Meal Plan';
    case 'expired':
      return 'Expired';
    case 'cancelled':
      return 'Cancelled Appointment';
    case 'complete':
      return 'Completed';
    default:
      return status.charAt(0).toUpperCase() + status.slice(1);
  }
};